<div class="container-fluid dashboard-container">
  <!-- Header Section with Greeting -->
  <div class="dashboard-header">
    <div class="greeting-section">
      <h2 class="greeting-text">{{ greeting }}, {{ userFirstName }}</h2>
      <p class="date-text">{{ time_str }}</p>
    </div>
    <div class="weather-map-section">
      <iframe
        [src]="radarMapUrl"
        class="weather-radar-frame"
        frameborder="0"
        loading="eager"
        referrerpolicy="no-referrer-when-downgrade"
        allowtransparency="true">
      </iframe>
    </div>
    <div class="weather-section">
      <div class="weather-card" *ngIf="weatherData && !weatherLoading">
        <div class="weather-main">
          <img class="weather-icon-large" [src]="getWeatherIconUrl(weatherData.weather[0].icon)" [alt]="weatherData.weather[0].description">
          <div class="weather-temp-large">{{ weatherData.main.temp | number:'1.0-0' }}°</div>
        </div>
        <div class="weather-details">
          <div class="weather-location-name">{{ weatherData.name }}</div>
          <div class="weather-desc-text">{{ weatherData.weather[0].description }}</div>
          <div class="weather-stats">
            <span><i class="fas fa-thermometer-half"></i> {{ weatherData.main.feels_like | number:'1.0-0' }}°</span>
            <span><i class="fas fa-wind"></i> {{ weatherData.wind.speed | number:'1.0-0' }} mph</span>
            <span><i class="fas fa-tint"></i> {{ weatherData.main.humidity }}%</span>
          </div>
        </div>
      </div>
      <div class="weather-loading" *ngIf="weatherLoading">
        <i class="fas fa-spinner fa-spin"></i> Loading...
      </div>
      <div class="weather-error" *ngIf="weatherError">
        <i class="fas fa-exclamation-triangle"></i> Weather unavailable
      </div>
    </div>
  </div>

  <!-- Stats Cards Row -->
  <div class="stats-row">
    <div class="stat-card clickable" (click)="navigateToMatters()">
      <i class="fas fa-briefcase stat-icon"></i>
      <div class="stat-label">Active Matters</div>
      <div class="stat-value">{{ userShowData.stats?.active_matters || 0 }}</div>
    </div>
    <div class="stat-card clickable" (click)="navigateToEvents()">
      <i class="fas fa-calendar-day stat-icon"></i>
      <div class="stat-label">Today's Events</div>
      <div class="stat-value text-info">{{ userShowData.stats?.todays_events || 0 }}</div>
    </div>
    <div class="stat-card">
      <i class="fas fa-bell stat-icon"></i>
      <div class="stat-label">Pending Reminders</div>
      <div class="stat-value" [ngClass]="{'text-warning': userShowData.stats?.pending_reminders > 0}">
        {{ userShowData.stats?.pending_reminders || 0 }}
      </div>
    </div>
  </div>

  <!-- Main Content Cards -->
  <div class="dashboard-cards">
    <!-- Reminders Card -->
    <div class="dashboard-card">
      <div class="card-header-custom">
        <h4 class="card-title-custom">
          <i class="fas fa-bell text-warning"></i>
          Reminders
        </h4>
      </div>
      <div class="card-body-custom">
        <app-dashboard-reminder (remindersDismissed)="onRemindersDismissed($event)"></app-dashboard-reminder>
      </div>
    </div>

    <!-- Favorites Card -->
    <div class="dashboard-card">
      <div class="card-header-custom">
        <h4 class="card-title-custom">
          <i class="fas fa-star text-warning"></i>
          Favorites
        </h4>
      </div>
      <div class="card-body-custom">
        <div class="matter-list">
          <div *ngIf="mattersLoading" class="empty-state">
            <i class="fas fa-spinner fa-spin text-muted"></i>
          </div>
          <ng-container *ngIf="!mattersLoading && !mattersLoadError">
            <div *ngFor="let matter of favorites" class="matter-item" [ngClass]="{'matter-inactive': !matter.is_active}">
              <a [routerLink]="'/matters/' + matter.id" class="matter-link" [title]="matter.number + ' - ' + matter.case_name">
                <span class="matter-number">{{ matter.number }}</span>
                <span class="matter-name">{{ matter.case_name }}</span>
              </a>
            </div>
          </ng-container>
          <div *ngIf="!mattersLoading && !mattersLoadError && favorites.length === 0" class="empty-state">
            <i class="fas fa-star text-muted"></i>
            <p>No favorites yet</p>
          </div>
          <div *ngIf="!mattersLoading && mattersLoadError" class="empty-state">
            <i class="fas fa-exclamation-circle text-muted"></i>
            <p>Favorites did not load</p>
            <button class="state-action-btn" type="button" (click)="loadUserMatters()">Retry</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Matters Card -->
    <div class="dashboard-card">
      <div class="card-header-custom">
        <h4 class="card-title-custom">
          <i class="fas fa-history text-info"></i>
          Recent Matters
        </h4>
      </div>
      <div class="card-body-custom">
        <div class="matter-list">
          <div *ngIf="mattersLoading" class="empty-state">
            <i class="fas fa-spinner fa-spin text-muted"></i>
          </div>
          <ng-container *ngIf="!mattersLoading && !mattersLoadError">
            <div *ngFor="let matter of recents" class="matter-item" [ngClass]="{'matter-inactive': !matter.is_active}">
              <a [routerLink]="'/matters/' + matter.id" class="matter-link" [title]="matter.number + ' - ' + matter.case_name">
                <span class="matter-number">{{ matter.number }}</span>
                <span class="matter-name">{{ matter.case_name }}</span>
              </a>
            </div>
          </ng-container>
          <div *ngIf="!mattersLoading && !mattersLoadError && recents.length === 0" class="empty-state">
            <i class="fas fa-history text-muted"></i>
            <p>No recent matters</p>
          </div>
          <div *ngIf="!mattersLoading && mattersLoadError" class="empty-state">
            <i class="fas fa-exclamation-circle text-muted"></i>
            <p>Recent matters did not load</p>
            <button class="state-action-btn" type="button" (click)="loadUserMatters()">Retry</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Events Card -->
    <div class="dashboard-card">
      <div class="card-header-custom">
        <h4 class="card-title-custom">
          <i class="fas fa-calendar-alt text-primary"></i>
          Upcoming Events
          <button class="btn btn-link btn-sm add-event-btn" type="button" (click)="openNewEvent()">
            <i class="fas fa-plus-circle"></i> Add
          </button>
        </h4>
      </div>
      <div class="card-body-custom">
        <app-event-home></app-event-home>
      </div>
    </div>
  </div>
</div>
